<template>
  <RouterLink
    v-if="tagName === 'RouterLink'"
    :to="{ name: 'home' }"
    :title="htmlDecode('Go to home page')"
  >
    <Logo :color="color || 'color'" />
  </RouterLink>
  <a
    v-else-if="tagName === 'a'"
    :href="utmHref(siteUrl, 'logo-click')"
    target="_blank"
    rel="self"
    :title="htmlDecode('Go to our website')"
  >
    <Logo :color="color || 'color'" />
  </a>
</template>

<script>
import Logo from '@/components/Logo.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'LogoLink',

  components: {
    Logo
  },

  props: {
    color: {
      type: String,
      default: undefined
    },
  },

  computed: {
    ...mapGetters([
      'isDirectRoute',
      'myStore',
    ]),
    siteOptions() {
      return this.myStore(['options'])
    },
    siteLinksout() {
      const { siteOptions } = this
      const { logo_linksout } = siteOptions
      return logo_linksout ?? true
    },
    siteUrl() {
      const { siteOptions } = this
      const { website_url } = siteOptions
      return website_url ?? ''
    },
    isLogoLinkout() {
      const { isDirectRoute, siteLinksout, siteUrl } = this
      return (isDirectRoute || siteLinksout) && siteUrl
    },
    tagName() {
      const { isLogoLinkout } = this
      return isLogoLinkout ? 'a' : 'RouterLink'
    },
  }
}
</script>
